import JobAddPage from './add'
export default JobAddPage
